import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { Breadcrumb, LoadingContainer, Panels, Bar } from 'peach/components'
import { getName } from 'peach/helpers'

import { Page, Clickable, ConfirmDialog, DynamicForm } from 'core/components'
import {
  useLoanTapeTypeGet,
  useLoanTapeTypeUpdate,
  useLoanTapeTypeDelete,
} from 'core/types'
import { loanTapeTypeSchema } from 'core/utils/generated/formSchemas'

const LoanTapeType = () => {
  const history = useHistory()
  const { url } = useRouteMatch()
  const { companyId, loanTapeTypeId } = useParams<{
    companyId?: string
    loanTapeTypeId?: string
  }>()

  const {
    data: tapeType,
    isLoading,
    refetch,
  } = useLoanTapeTypeGet({
    companyId,
    loanTapeTypeId,
  })

  const { mutateAsync: updateTapeType } = useLoanTapeTypeUpdate({
    companyId,
    loanTapeTypeId,
  })

  const { mutateAsync: deleteTapeType } = useLoanTapeTypeDelete({
    companyId,
    loanTapeTypeId,
  })

  const onDelete = async () => {
    await deleteTapeType()
    history.push(`/companies/${companyId}/loan-tape-types`)
  }

  const title = getName(tapeType) || 'Loan Tape Type'

  return (
    <Panels header={<Bar title={title} />}>
      <LoadingContainer isLoading={isLoading}>
        <Breadcrumb title={title} to={url} />
        <Page variant='full'>
          <DynamicForm
            data={tapeType || {}}
            fieldEditMode='toggle'
            fieldOverrides={{
              fields: 'JsonInput',
              fieldNameMappings: 'JsonInput',
              loanMetaDataFields: 'JsonInput',
            }}
            omitFields={[
              'id',
              'createdAt',
              'updatedAt',
              'deletedAt',
              'object',
              'companyId',
            ]}
            onSubmit={async (payload: any) => {
              await updateTapeType(payload)
              await refetch()
            }}
            otherActions={[
              <ConfirmDialog
                key='delete-action'
                onConfirm={onDelete}
                title='Delete Loan Tape Type'
              >
                <Clickable variant='outline'>Delete</Clickable>
              </ConfirmDialog>,
            ]}
            schema={loanTapeTypeSchema}
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanTapeType
